/* eslint-disable */
import { PageContent } from "components/PageContent/index";
import { IShopSection } from "contexts/WebStoreProvider/types";
import { isEqualWith } from "lodash";
import { createContext, createRef, useEffect, useState } from "react";
import SingleItems from "./components/SingleItems";
import PageTopNav, { ISectionMenuItem } from "components/PageTopNav";
import PageTopNavV2 from "components/PageTopNavV2";
import { useEnvContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppSelector } from "hooks";
import { selectShopSectionsState } from "redux/slices/shop-sections";
import FTUEInfoButton from "./components/FTUEInfoButton";
import LoyaltyLearnMoreCard from "./components/LoyaltyLearnMoreCard";
import { useTriggerLPFTUE } from "./hooks/useTriggerLPFTUE";

// eslint-disable-next-line
export const LoyaltyContext = createContext({} as any);

const LoyaltyShop = () => {
	const { shopSections } = useAppSelector(selectShopSectionsState);
	const [sectionMenuData, setSectionMenuData] = useState<ISectionMenuItem[]>(
		[]
	);
	const [loyaltyShopSections, setLoyaltyShopSections] = useState<
		IShopSection[]
	>([]);
	const { isFeatureFlagEnabled } = useEnvContext();

	const dailyDealsFiltered = shopSections?.loyaltyShopSections.filter(
		(offer) =>
			offer.name === "daily_deals" &&
			isFeatureFlagEnabled(FeaturesFlags.LOYALTY_SHOP_CAROUSEL)
	);

	const isFTUEEnabled =
		isFeatureFlagEnabled(FeaturesFlags.FTUE_V2) ||
		isFeatureFlagEnabled(FeaturesFlags.LOYALTY_SHOP_FTUE);
	const isCarouselEnabled = isFeatureFlagEnabled(
		FeaturesFlags.LOYALTY_SHOP_CAROUSEL
	);

	useTriggerLPFTUE({ sectionMenuData });

	useEffect(() => {
		window?.scrollTo(0, 0);
	}, []);

	//Prevent rerendering when processing storeRaw
	useEffect(() => {
		if (!shopSections?.loyaltyShopSections) {
			return;
		}
		if (isEqualWith(shopSections?.loyaltyShopSections, loyaltyShopSections)) {
			return;
		}
		setLoyaltyShopSections(shopSections?.loyaltyShopSections);
	}, [shopSections?.loyaltyShopSections]);

	useEffect(() => {
		setSectionMenuData(
			shopSections?.loyaltyShopSections.map((data: IShopSection) => {
				const { name, title: text, iconImageUrl: icon } = data;
				const newRef = createRef();

				return {
					name,
					text,
					icon,
					sectionRef: newRef,
					analytics_source: "loyalty"
				};
			})
		);
	}, [loyaltyShopSections]);

	return (
		<LoyaltyContext.Provider value={{ sectionMenuData }}>
			{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
				<PageTopNavV2
					sectionMenuData={sectionMenuData}
					showSubmenu={dailyDealsFiltered.length === 0}
				/>
			) : (
				<PageTopNav sectionMenuData={sectionMenuData} />
			)}
			<PageContent source={"loyalty_page"} enableBackToTop>
				{isCarouselEnabled && isFTUEEnabled && (
					<FTUEInfoButton className="loyalty-shop" />
				)}

				{!isCarouselEnabled && (
					<LoyaltyLearnMoreCard hasFTUEInfoButton={isFTUEEnabled} />
				)}
				<SingleItems />
			</PageContent>
		</LoyaltyContext.Provider>
	);
};

export default LoyaltyShop;
